import { EditorState, ContentState } from 'draft-js';

export default (editorState) =>
    EditorState.moveFocusToEnd(EditorState.push(editorState, ContentState.createFromText('')));
